export enum APPEAL_ACTIONS {
    APPROVE = 'ALAPP',
    CANCEL = 'ALCAN',
    DENY = 'ALDEN',
    INCOMPLETE = 'ALINC',
    FORWARD_TO_DESIGNEE = 'ALFTD'
}
